/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useEffect, useState } from "react";
import { useBoolean, useId } from "@fluentui/react-hooks";
import {
  Callout,
  DefaultButton,
  FontWeights,
  IPersonaSharedProps,
  mergeStyleSets,
  Persona,
  PersonaInitialsColor,
  PersonaPresence,
  PersonaSize,
  Stack,
} from "@fluentui/react";
// import {  baseImageUrl, splitExceptionDetail, stringToUpperCamelCase } from "../../utils/helper/helpers";
import personaServicio from "../../services/persona/personaServicio";
import {
  baseImageUrl,
  stringToUpperCamelCase,
  validarDominio,
} from "../../utils/helpers/helpers";
import { IPersona } from "../../Interfaces/IPersona";
import AuthService from "../../services/authService";
import { CLAIM_PERSONA_ID } from "../../utils/helpers/roleHelpers";
import { CambiarContrasenia } from "../cambiarContrasenia/CambiarContrasenia";
// import { IException } from "../../Interfaces/base/IException";
// import { IPersona } from "../../Interfaces/IPersona";
// import AuthService from "../../services/authServices";
// import { CLAIM_PERSONA_ID } from "../../utils/helper/roleHelpers";

interface LogoutProps {
  /**NOMBRE DE USUARIO LOGEADO */
  userName?: string;
  /**EMAIL DE USUARIO LOGEADO */
  email?: string;
  /**LINK QUE TE LLEVA AL PERFIL DE USUARIO LOGEADO */
  linkPerfil?: string;
  /**EVENTO PARA MANEJAR EL LOGOUT, AL DAR CLICK EN El BOTON CERRAR SESION */
  handleSignout?:
    | React.MouseEventHandler<
        HTMLSpanElement | HTMLAnchorElement | HTMLButtonElement | HTMLDivElement
      >
    | undefined;
}

const Logout: FunctionComponent<LogoutProps> = (prop) => {
  /**LOGAOUT */
  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] =
    useBoolean(false);
  const buttonId = useId("callout-button");
  const labelId = useId("callout-label");
  const descriptionId = useId("callout-description");
  const [info, setInfo] = useState<IPersona>(null!);

  const [usuarioDominio, setUsuarioDominio] = useState(true);

  const [
    isOpenPanelCambiar,
    { setTrue: openPanelCambiar, setFalse: dismissPanelCambiar },
  ] = useBoolean(false);

  const onRenderPrimaryText = () => (
    <p className={stylesLogout.onRenderPrimaryText}>
      <strong>
        {stringToUpperCamelCase(
          info ? info.primerNombre + " " + info.apellidoPaterno : prop.userName!
        )}
      </strong>
    </p>
  );
  const onRenderSecondaryText = () => (
    <p className={stylesLogout.onRenderSecondaryText}>
      {prop.email?.toLocaleLowerCase()}{" "}
    </p>
  );
  const onRenderTertiaryText = () => (
    <h5 className={stylesLogout.onRenderTertiaryText}>En linea</h5>
  );
  // const onRenderOptionalText = () => (
  //     <>
  //         <Link to={prop.linkPerfil ? prop.linkPerfil : ""}>Ver perfil</Link>
  //     </>
  // )

  /* api */
  useEffect(() => {
    dataPersona();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (prop.email !== undefined) {
      setUsuarioDominio(validarDominio(prop.email));
    }
  }, [prop.email]);

  // /**PersonaId de usuario */
  function obtenerUsuario() {
    return AuthService.getInfoToken(CLAIM_PERSONA_ID);
  }

  const dataPersona = () => {
    if (obtenerUsuario() !== "") {
      personaServicio
        .UsuarioLogueado()
        .then((res) => {
          setInfo(res.data);
        })
        .catch((e: Error) => {
          alert(e.message);
        });
    }
  };

  const examplePersona: IPersonaSharedProps = {
    // imageUrl: TestImages.personaMale,
    // text: `${prop.userName}`,
    // optionalText: 'En linea ',
    imageUrl: info ? info.foto : baseImageUrl,
    imageInitials: "?",
    secondaryText: "En linea",
    tertiaryText: "En linea",
  };
  return (
    <>
      <Persona
        {...examplePersona}
        id={buttonId}
        initialsColor={PersonaInitialsColor.warmGray}
        imageInitials={`${prop.userName?.substring(0, 1)}`}
        size={PersonaSize.size32}
        presence={PersonaPresence.online}
        imageAlt="status is online"
        onClick={toggleIsCalloutVisible}
        className={stylesLogout.persona1}
      />
      {isCalloutVisible && (
        <Callout
          className={stylesLogout.callout}
          ariaLabelledBy={labelId}
          ariaDescribedBy={descriptionId}
          role="dialog"
          gapSpace={0}
          target={`#${buttonId}`}
          onDismiss={toggleIsCalloutVisible}
          setInitialFocus>
          {/* <Stack verticalAlign="center" horizontal horizontalAlign="space-between" style={{ fontSize: '0.6875rem' }}>
                        <span>.</span>
                        <DefaultButton
                            text="Cerrar sesion"
                            onClick={prop.handleSignout}
                            className={stylesLogout.buttonSesion}
                        />
                    </Stack> */}
          <br />
          <Persona
            {...examplePersona}
            id={buttonId}
            initialsColor={PersonaInitialsColor.warmGray}
            imageInitials={`${prop.userName?.substring(0, 1)}`}
            onRenderPrimaryText={onRenderPrimaryText}
            onRenderSecondaryText={onRenderSecondaryText}
            onRenderTertiaryText={onRenderTertiaryText}
            size={PersonaSize.size72}
            presence={PersonaPresence.online}
            imageAlt="Annie Lindqvist, status is online"
            onClick={toggleIsCalloutVisible}
            className={stylesLogout.persona1}
          />
          <br />
          <div hidden={usuarioDominio}>
            <Stack verticalAlign="start" horizontal horizontalAlign="start">
              <DefaultButton
                onRenderText={(arg) => <span>Actualizar Contraseña</span>}
                // iconProps={{ iconName: 'Lock12', className: stylesLogout.iconPropsCerrarSesion }}
                className={stylesLogout.buttonOtherSesion}
                onClick={() => {
                  openPanelCambiar();
                }}
              />
            </Stack>
          </div>
          <Stack verticalAlign="start" horizontal horizontalAlign="start">
            <DefaultButton
              onRenderText={(arg) => <span>Cerrar sesión</span>}
              // iconProps={{ iconName: 'Lock12', className: stylesLogout.iconPropsCerrarSesion }}
              className={stylesLogout.buttonOtherSesion}
              onClick={prop.handleSignout}
            />
          </Stack>
        </Callout>
      )}
      <CambiarContrasenia
        isOpen={isOpenPanelCambiar}
        onDismiss={dismissPanelCambiar}
        email={prop.email!.toLocaleLowerCase()}
      />
    </>
  );
};

export default Logout;

const stylesLogout = mergeStyleSets({
  button: {
    width: 130,
  },
  callout: {
    width: 350,
    maxWidth: "90%",
    padding: "10px 14px",
  },
  title: {
    marginBottom: 12,
    fontWeight: FontWeights.semilight,
  },
  link: {
    display: "block",
    marginTop: 20,
  },
  persona1: {
    color: "#fff",
    cursor: "pointer",
  },
  buttonSesion: {
    border: "none",
    fontSize: "0.6875rem",
  },
  buttonOtherSesion: {
    padding: "1.2rem",
    border: "none",
    width: "100%",
    textAlign: "start",
    fontSize: "0.75rem",
    fontStyle: "normal",
    fontWeight: "none",
  },
  iconPropsCerrarSesion: {
    fontSize: "1.4rem",
    fontWeight: "lighter",
    padding: "0.3125rem",
  },
  onRenderPrimaryText: {
    padding: 0,
    margin: 2,
    fontSize: "1rem",
  },
  onRenderSecondaryText: {
    padding: 0,
    margin: 2,
    fontSize: "0.75rem",
  },
  onRenderTertiaryText: {
    padding: 0,
    margin: 2,
    fontSize: "0.75rem",
  },
});
